export const TOTAL_PUBLIC_SUPPLY: number = 2000;
export const PUBLIC_MINT_COUNT_DISPLAY_THRESHOLD: number = 1000;

